import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpDownSortComponent } from '../up-down-sort/up-down-sort.component';
import { SearchInputComponent } from '../search-input/search-input.component';
import { FormsModule } from '@angular/forms';
import { ConfirmationModalComponent } from '../confirmation-component.modal';
import { NumberDirective } from '../directive/numbers';
import { OnlyNumberDirective } from '../directive/only-number.directive';
import { AddressBookModalComponent } from '../address-book-modal/address-book-modal.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ImgListComponent } from '../img-list/img-list.component';
import { PrintModalComponent } from '../print-modal/print-modal.component';
import { UploadFileComponent } from '../upload-file/upload-file.component';
import { QRCodeModalComponent } from '../qrcode-modal/qrcode-modal.component';
import { QRCodeModule } from 'angularx-qrcode';
import { StatusInfoboxComponent } from '../status-infobox/status-infobox.component';
import { CutOffTimePipe } from '../../pipe/cutOffTime.pipe';
import { defineLocale, enGbLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ViewPodModal } from '../view-pod-modal/view-pod-modal.component';

const component = [
  UpDownSortComponent,
  ConfirmationModalComponent,
  SearchInputComponent,
  NumberDirective,
  AddressBookModalComponent,
  OnlyNumberDirective,
  PrintModalComponent,
  ImgListComponent,
  UploadFileComponent,
  QRCodeModalComponent,
  StatusInfoboxComponent,
  CutOffTimePipe,
  ViewPodModal
]

@NgModule({
  declarations: [
    component
  ],
  entryComponents:[
    ViewPodModal,
    ConfirmationModalComponent,
    ImgListComponent,
    QRCodeModalComponent,
    AddressBookModalComponent,
    QRCodeModalComponent,
    PrintModalComponent],
  imports: [
    PaginationModule.forRoot(),
    FormsModule,
    QRCodeModule,
    CommonModule
  ],
  exports:[component]
})
export class SharedComponentModule {
  constructor(localeService: BsLocaleService) {
    defineLocale('en-gb', enGbLocale);
    localeService.use('en-gb');
  }
}
